import { makeStyles, Theme } from '@material-ui/core/styles';
import { indigo, pink } from '@material-ui/core/colors';

const useStyles = makeStyles((theme: Theme) => ({
  '@global': {
    '.block-picker': {
      boxShadow: 'none !important',
      borderRadius: '0 !important',
    },
    '.block-picker > div': {
      borderRadius: '0 !important',
    },
  },
  root: {
    flexGrow: 1,
    minWidth: 830,
  },
  tabBarWrap: {
    borderBottom: '1px solid #e8e8e8',
  },
  table: {
    minWidth: 650,
  },
  infoTextField: {
    width: '100%',
    paddingBottom: theme.spacing(1),
  },
  createAutomatedCollectionWrap: {
    width: '940px',
  },
  verticalGrid: {},
  contentSettingWrap: {
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(3),
    padding: theme.spacing(3),
  },
  sectionTitle: {
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  flexSectionTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  chip: {
    marginLeft: theme.spacing(1.5),
  },
  colorPicker: {
    border: '1px solid #e8e8e8',
  },
  radioButtonGroups: {
    flexDirection: 'row',
    '& > label': {
      flex: '1',
    },
    marginBottom: theme.spacing(3),
  },

  formControl: {
    margin: theme.spacing(1),
    minWidth: 96,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },

  queryButton: {
    width: '100px',
  },
  testResultImage: {
    width: '45px',
    height: '80px',
    objectFit: 'cover',
    backgroundColor: '#e8e8e8',
    marginRight: theme.spacing(2),
  },
  testResultWriter: {
    color: theme.palette.text.hint,
  },
  testResultStoryId: {
    marginTop: theme.spacing(1.2),
    marginBottom: theme.spacing(),
  },
  testResultWrap: {
    height: '418px',
    overflowY: 'scroll',
    border: '1px solid #e8e8e8',
    '&::-webkit-scrollbar': {
      WebkitAppearance: 'none',
    },

    '&::-webkit-scrollbar:vertical': {
      width: '8px',
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '8px',
      border: '0 none',
      backgroundColor: 'rgba(0, 0, 0, .6)',
    },
  },
  testResultDescription: {
    marginLeft: theme.spacing(1),
  },
  testResultDescriptionError: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: theme.palette.error.main,
  },
  testResultNoResult: {
    height: '418px',
    border: '1px solid #e8e8e8',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  nextFireTitle: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  mainButton: {
    marginRight: theme.spacing(1),
  },
  testButtonProgress: {
    color: indigo[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  submitButtonProgress: {
    color: pink[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  tableRow: {
    cursor: 'pointer',
  },
  nestedTabsRoot: {
    minHeight: 36,
  },
  nestedTabRoot: {
    minHeight: 36,
  },
  nestedTabWrapper: {
    position: 'absolute',
    fontSize: '13px !important',
    zIndex: 1,
  },
  noDataBox: {
    height: '200px',
  },
  bottomButtons: {
    width: '100%',
    flex: 1,
    justifyContent: 'flex-end',
  },
  paper: {
    padding: theme.spacing(3),
  },
  featuredCardSetRow: {
    cursor: 'pointer',
    height: 63,
  },
  linkedWrap: {
    marginLeft: 16,
    height: 256,
  },
  linkedItemBox: {
    height: 134,
    border: 'solid 1px #dcdcdc',
    overflow: 'scroll',
  },
  linkedDetailItem: {
    marginBottom: 25,
  },
  internalTitle: {
    fontWeight: 500,
    color: theme.palette.primary.main,
    whiteSpace: 'nowrap',
    maxWidth: 150,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  featuredTitle: {
    whiteSpace: 'nowrap',
    maxWidth: 150,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  titleEmphasize: {
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  featuredCardListCoverImage: {
    display: 'inline-block',
    width: 64,
    height: 36,
    borderRadius: 1,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
  popoverItemTitle: {
    flexGrow: 1,
  },
  popoverPriority: {
    fontSize: 14,
    color: theme.palette.primary.main,
  },
  capital: {
    textTransform: 'capitalize',
  },

  linkCountText: {
    display: 'inline-block',
    cursor: 'pointer',
    padding: '4px',
    '&:hover': {
      fontWeight: 'bold',
      color: theme.palette.primary.main,
      textDecoration: 'underline',
    },
  },
}));

export default useStyles;
